export default __webpack_public_path__ + "static/media/url-shorteningImg_2.51b2b205.png";